<template>
  <O3D class="">
    <!-- <AmbinetLight :intensity="0.5"></AmbinetLight>
    <DirectionalLight :intensity="0.5"></DirectionalLight>
    <HemisphereLight :intensity="0.5"></HemisphereLight> -->

    <!-- <O3D>
      <O2DHTML v-if="gameO3D" @o3d="gameO3D.add($event)" :py="0.3" class="z-50 flex flex-row">
        <div class="inline-block bg-white px-5 py-2 m-1 rounded-full text-center">
          More...
        </div>
      </O2DHTML>
    </O3D> -->

    <O3D v-if="gameO3D && !nolight" @o3d="syncPositionWithCharacter($event)">

      <O3D :px="0" :pz="10" :py="50">
        <PointLight :decay="2" :distance="0" :color="0xffffff" :helper="isDev && isOff" :intensity="0.4"></PointLight>
      </O3D>

      <O3D :px="0" :pz="-10" :py="18">
        <PointLight :decay="2" :distance="0" :color="0xffffff" :helper="isDev && isOff" :intensity="0.4"></PointLight>
      </O3D>

      <O3D :px="20" :pz="20" :py="10">
        <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOff" :intensity="0.09"></HemisphereLight>
      </O3D>

      <O3D :px="-20" :pz="20" :py="10">
        <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOff" :intensity="0.09"></HemisphereLight>
      </O3D>

      <O3D :px="20" :pz="-20" :py="10">
        <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOff" :intensity="0.09"></HemisphereLight>
      </O3D>

      <O3D :px="-20" :pz="-20" :py="10">
        <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOff" :intensity="0.09"></HemisphereLight>
      </O3D>

      <O3D :px="0" :pz="0" :py="0">
        <AmbinetLight :color="0xffffff" :helper="isDev && isOff" :intensity="0.2"></AmbinetLight>
      </O3D>

    </O3D>

    <slot></slot>

    <!-- <div ref="touchdiv" class="absolute z-10 top-0 left-0 w-full h-full"></div> -->

    <div v-if="game && game.charReady && showToolsBox && game.moves" class="p-1 select-none lg:select-text absolute z-20 top-0 left-0 text-xs lg:text-sm text-white w-56 overflow-y-auto moves-box">
      <!-- <div v-if="isDev">
        <a v-for="(charItem, i) in characterList" :key="charItem + i" @click="character = charItem" class="block px-2 mx-1 my-1 border-gray-100 border" :style="{ backgroundColor: charItem === character ? '#4299e1' : 'rgba(0,0,0,0.3)' }">{{ charItem }}</a>
      </div> -->

      <div class="p-1" v-if="mode === 'full'">
        <a class="inline-block bg-transp-black px-2 mr-1 mb-1 border-gray-100 border" @click="moveListFilter = 'all'" :style="{ backgroundColor: moveListFilter === 'all' ? 'green' : '' }">All</a>
        <a class="inline-block bg-transp-black px-2 mr-1 mb-1 border-gray-100 border" @click="moveListFilter = 'church'" :style="{ backgroundColor: moveListFilter === 'church' ? 'green' : '' }">Church</a>
        <a class="inline-block bg-transp-black px-2 mr-1 mb-1 border-gray-100 border" @click="moveListFilter = 'ready'" :style="{ backgroundColor: moveListFilter === 'ready' ? 'green' : '' }">Ready</a>
        <a class="inline-block bg-transp-black px-2 mr-1 mb-1 border-gray-100 border" @click="moveListFilter = 'posture'" :style="{ backgroundColor: moveListFilter === 'posture' ? 'green' : '' }">Posture</a>
        <a class="inline-block bg-transp-black px-2 mr-1 mb-1 border-gray-100 border" @click="moveListFilter = 'dance'" :style="{ backgroundColor: moveListFilter === 'dance' ? 'green' : '' }">Dance</a>
        <a class="inline-block bg-transp-black px-2 mr-1 mb-1 border-gray-100 border" @click="moveListFilter = 'football'" :style="{ backgroundColor: moveListFilter === 'football' ? 'green' : '' }">Football</a>
        <a class="inline-block bg-transp-black px-2 mr-1 mb-1 border-gray-100 border" @click="moveListFilter = 'action'" :style="{ backgroundColor: moveListFilter === 'action' ? 'green' : '' }">Action</a>
        <a class="inline-block bg-transp-black px-2 mr-1 mb-1 border-gray-100 border" @click="moveListFilter = 'combat'" :style="{ backgroundColor: moveListFilter === 'combat' ? 'green' : '' }">Combat</a>
        <a class="inline-block bg-transp-black px-2 mr-1 mb-1 border-gray-100 border" @click="moveListFilter = 'gun'" :style="{ backgroundColor: moveListFilter === 'gun' ? 'green' : '' }">Gun</a>
        <a class="inline-block bg-transp-black px-2 mr-1 mb-1 border-gray-100 border" @click="moveListFilter = 'control'" :style="{ backgroundColor: moveListFilter === 'control' ? 'green' : '' }">Control</a>
      </div>

      <!-- <a :ref="`item-${moveItem._id}`" v-for="moveItem in game.moves.filter(actionFilter)" :key="moveItem._id + moveItem.displayName" @click="gui('play-move', { move: moveItem }); lastClickedMove = moveItem" class="block px-2 mx-1 my-1 border-gray-100 border" :style="{ backgroundColor: lastClickedMove === moveItem ? '#4299e1' : 'rgba(0,0,0,0.3)' }">{{ moveItem.displayName }}</a> -->
      <a :ref="`item-${moveItem._id}`" v-for="moveItem in game.moves.filter(actionFilter)" :key="moveItem._id + moveItem.displayName" @click="onChooseMove({ move: moveItem })" class="block px-2 mx-1 my-1 border-gray-100 border" :style="{ backgroundColor: lastClickedMove === moveItem ? '#4299e1' : 'rgba(0,0,0,0.3)' }">{{ moveItem.displayName }}</a>

    </div>

    <div class="touch-action-manipulation select-none absolute z-30 bottom-0 left-0 pl-5 pb-5" v-if="game && game.charReady">
      <div class="touch-action-manipulation select-none">
        <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border text-20 text-white bg-white" @click="showToolsBox = !showToolsBox">
          <img class="touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/party.svg" alt="">
        </div>
        <div v-if="mode !== 'church'" class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border bg-white text-20 text-white" @click="gui('key-x', true)">
          <img class="touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/gamepad.svg" alt="">
        </div>
      </div>
      <div class="touch-action-manipulation select-none flex">
        <!-- <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border  text-20 text-white" :class="{ 'bg-blue-500': game.useGyro, 'bg-white': !game.useGyro }" @click="() => gui('toggle-gyro', {})">
          <img class="touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/gyro.svg" alt="">
        </div> -->
        <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 w-12 h-12 border-gray-100 border  text-20 text-black" :class="{ 'bg-blue-500': game.useGyro, 'bg-white': !game.useGyro }" @click="() => gui('toggle-gyro', {})">
          AR
        </div>
        <div v-show="game && !game.useGyro" class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border bg-white text-20 text-white" @click="() => gui('cycle-cam-mode', {})">
          <img v-show="game.viewCameraMode === 'freecam'" class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/touch.svg" alt="">
          <img v-show="game.viewCameraMode !== 'freecam'" class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/camcorder.svg" alt="" />
        </div>
      </div>
      <div class="touch-action-manipulation select-none" @touchstart.prevent="() => {}" @touchmove.prevent="() => {}">
        <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border bg-white text-20 text-white" @touchstart="gui('go-forward', true)" @mousedown="gui('go-forward', true)"  @touchend="gui('go-forward', false)" @mouseup="gui('go-forward', false)">
          <img class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/up.svg" alt="">
        </div>
        <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border bg-white text-20 text-white" @touchstart="gui('go-backward', true)" @mousedown="gui('go-backward', true)" @touchend="gui('go-backward', false)" @mouseup="gui('go-backward', false)">
          <img class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/down.svg" alt="">
        </div>
      </div>
    </div>

    <div class="touch-action-manipulation select-none  absolute z-30 bottom-0 right-0 pr-5 pb-5" v-if="game && game.charReady">
      <div class="touch-action-manipulation select-none flex justify-end">
        <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border text-20 text-white bg-white" @click="goToPage()">
          <!-- <img v-if="mode !== 'church'" class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/church.svg" alt=""> -->
          <img class=" touch-action-manipulation scale-100 transform select-none  pointer-events-none" src="./img/menu.svg" alt="">
        </div>
      </div>

      <div class="touch-action-manipulation select-none" @touchstart.prevent="() => {}" @touchmove.prevent="() => {}">
        <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border bg-white text-20 text-white" @touchstart="gui('key-r', true)" @mousedown="gui('key-r', true)"  @touchend="gui('key-r', false)" @mouseup="gui('key-r', false)">
          <img v-show="game && game.moodType === 'peaceful'" class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/love.svg" alt="">
          <img v-show="game && game.moodType === 'fighting'" class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/fight1.svg" alt="">
        </div>
        <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border bg-white text-20 text-white" @touchstart="gui('key-t', true)" @mousedown="gui('key-t', true)"  @touchend="gui('key-t', false)" @mouseup="gui('key-t', false)">
          <img v-show="game && game.moodType === 'peaceful'" class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/dance.svg" alt="">
          <img v-show="game && game.moodType === 'fighting'" class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/fight2.svg" alt="">
        </div>
      </div>

      <div class="touch-action-manipulation select-none" v-show="game && !game.useGyro" @touchstart.prevent="() => {}" @touchmove.prevent="() => {}">
        <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border bg-white text-20 text-white" @touchstart="gui('turn-left', true)" @mousedown="gui('turn-left', true)"  @touchend="gui('turn-left', false)" @mouseup="gui('turn-left', false)">
          <img class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/turn-left.svg" alt="">
        </div>
        <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border bg-white text-20 text-white" @touchstart="gui('turn-right', true)" @mousedown="gui('turn-right', true)" @touchend="gui('turn-right', false)" @mouseup="gui('turn-right', false)">
          <img class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/turn-right.svg" alt="">
        </div>
      </div>

      <div class="touch-action-manipulation select-none" @touchstart.prevent="() => {}" @touchmove.prevent="() => {}">
        <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border bg-white text-20 text-white" @touchstart="gui('go-left', true)" @mousedown="gui('go-left', true)"  @touchend="gui('go-left', false)" @mouseup="gui('go-left', false)">
          <img class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/left.svg" alt="">
        </div>

        <div class="inline-block rounded-full touch-action-manipulation text-center select-none p-3 mx-1 my-1 border-gray-100 border bg-white text-20 text-white" @touchstart="gui('go-right', true)" @mousedown="gui('go-right', true)" @touchend="gui('go-right', false)" @mouseup="gui('go-right', false)">
          <img class=" touch-action-manipulation scale-75 transform select-none  pointer-events-none" src="./img/right.svg" alt="">
        </div>
      </div>
    </div>

    <div v-if="showLoading" class="absolute top-0 left-0 h-full w-full flex justify-center items-center" :class="{ 'bg-transp-black': !game.charReady }">
      <div class="px-6 py-3 rounded-full bg-white"> {{loadingPercentage.toFixed(2)}}% Loading...</div>
    </div>
  </O3D>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { LoadingManager } from '../../Reusable/LoadingManager'
import { Game } from './Game.js'
// import { EventDispatcher } from 'three'

export default {
  props: {
    nolight: {
      default: false
    },
    mode: {
      default: 'full'
    },
    char: {
      default: undefined
    }
  },
  mixins: [O3DG2],
  data () {
    return {
      char3d: false,
      gamechar: false,
      showDancing: false,
      gameO3D: false,
      useBloom: false,
      // toolbox
      showToolsBox: this.mode === 'full' && window.innerWidth > 500,
      moveListFilter: ' ',
      lastClickedMove: false,

      loadingPercentage: 0,
      showLoading: false,
      game: false
    }
  },
  watch: {
    moveListFilter () {
      if (this.game) {
        if (this.moveListFilter === 'dance') {
          this.game.viewCameraMode = 'freecam'
        } else if (this.moveListFilter === 'posture') {
          this.game.viewCameraMode = 'freecam'
        } else if (this.moveListFilter === 'combat') {
          this.game.viewCameraMode = 'freecam'
        } else if (this.moveListFilter === 'action') {
          this.game.viewCameraMode = 'freecam'
        } else if (this.moveListFilter === 'gun') {
          this.game.viewCameraMode = 'freecam'
        } else {
          this.game.viewCameraMode = 'firstperson'
        }
      }
    }
  },
  methods: {
    syncPositionWithCharacter (item) {
      this.o3d.remove(item)
      this.gamechar.out.o3d.add(item)
    },
    onChooseMove ({ move }) {
      this.lastClickedMove = move
      this.$root.$emit('play-move', { name: move.displayName })
    },
    goToPage () {
      this.$router.push('/menu')
    },
    actionFilter (item) {
      if (this.moveListFilter === 'all') {
        return true
      } else if (this.moveListFilter) {
        if (this.moveListFilter === item.type) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },

    gui (event, data) {
      this.game.dispatchEvent({ type: event, data: data })
    },

    setup () {
      // this.o3d.children.forEach(l => {
      //   this.o3d.remove(l)
      // })
      this.$root.$on('play-move', async ({ name }) => {
        this.gui('play-move', { move: { displayName: name } })
      })
      this.moveListFilter = 'all'
      if (this.mode === 'church') {
        this.moveListFilter = 'church'
        // this.showToolsBox = false
      }

      // let bus = new EventDispatcher()
      let gamechar = new Game({
        mode: this.mode,
        char: this.char,
        renderer: this.ctx.renderer,
        touchdiv: this.ctx.touchdiv,
        loop: this.onLoop,
        clean: this.onClean,
        camera: this.ctx.camera,
        scene: this.ctx.scene,
        cubeCam: this.ctx.cubeCam
      })

      this.gamechar = gamechar

      gamechar.out.done.then(() => {
        if (this.mode === 'full') {
          this.gui('key-x', true)
          this.gui('play-move', { move: { displayName: 'House Dancing' } })
        }
        this.$emit('ready', true)
        this.gameO3D = false
        this.$nextTick(() => {
          this.gameO3D = gamechar.out.o3d
        })
      })

      if (this.game) {
        this.o3d.remove(this.game.out.o3d)
      }
      this.game = gamechar
      this.o3d.add(gamechar.out.o3d)

      gamechar.out.o3d.scale.x = 10
      gamechar.out.o3d.scale.y = 10
      gamechar.out.o3d.scale.z = 10
      gamechar.out.o3d.rotation.y = Math.PI

      LoadingManager.hooks.push((v) => {
        if (v > 0 || !this.game.charReady) {
          this.showLoading = true
        }
        if (v === 1 && this.game.charReady) {
          this.showLoading = false
        }
        this.loadingPercentage = v * 100
        if (this.loadingPercentage < 0) {
          this.loadingPercentage = 0
        }
      })
    },

  },
  mounted () {
    this.setup()
    this.$watch('char', () => {
      this.$emit('reload-me')
    })
    // this.setupBloom()
  },
  beforeDestroy () {
  }
}
</script>

<style lang="postcss">
.moves-box{
  height: 170px;
}
@screen lg {
  .moves-box{
    height: calc(100% - 250px);
  }
}
.touch-action-manipulation{
  touch-action: manipulation;
}
.bg-transp-black{
  background-color: rgba(0,0,0,0.3);
}
.bg-transp-white{
  background-color: rgba(255,255,255,0.3);
}
.touch-action-manipulation {
  touch-action: manipulation;
}
</style>
